<div class="assessment-charts-container">

  <!-- Loading -->
  <div *ngIf="isLoading" class="text-center py-4">
    <mat-spinner diameter="40" class="d-inline"></mat-spinner>
    <p class="text-muted mt-2">Loading assessment charts...</p>
  </div>

  <!-- No Data -->
  <div *ngIf="!isLoading && !showAdmissionChart && !showDischargeChart" class="text-center py-4">
    <mat-icon style="font-size: 48px; width: 48px; height: 48px; color: #999;">bar_chart</mat-icon>
    <p class="text-muted mt-2">No assessment data found for the selected date range and centre(s).</p>
  </div>

  <!-- Charts Content -->
  <div *ngIf="!isLoading && (showAdmissionChart || showDischargeChart)">

    <p style="text-align: justify; text-justify: inter-word; margin-bottom: 20px;">
      The Psychological Assessment data is analyzed to determine the level of coping ability and mental/emotional
      well-being. The following is the graphical representation of this data.
    </p>

    <!-- Admission/Baseline Chart -->
    <div *ngIf="showAdmissionChart" class="chart-section">
      <div class="chart-wrapper">
        <app-apex-piechart
          *ngIf="admissionChartData.length >= 1 && doughnutChartLabels.length >= 1"
          [chartLabels]="doughnutChartLabels"
          [chartTitle]="'Admission/Baseline Psychological Assessment'"
          [chartData]="admissionChartData">
        </app-apex-piechart>

        <!-- Smiley Icons (hidden) -->
      </div>
    </div>

    <!-- Discharge/Final Baseline Chart -->
    <div *ngIf="showDischargeChart" class="chart-section" style="margin-top: 30px;">
      <div class="chart-wrapper">
        <app-apex-piechart
          *ngIf="dischargeChartData.length >= 1 && doughnutChartLabels.length >= 1"
          [chartLabels]="doughnutChartLabels"
          [chartTitle]="'Discharge/Final Baseline Assessments'"
          [chartData]="dischargeChartData">
        </app-apex-piechart>

        <!-- Smiley Icons (hidden) -->
      </div>
    </div>

    <!-- Frequency Legend -->
    <div class="frequency-legend" *ngIf="showAdmissionChart || showDischargeChart">
      <p>
        <strong>Frequency of low coping:</strong> The number of circumstances beneficiaries reported to be stressed
        and unable to cope.
      </p>
      <p>
        <strong>Frequency of moderate coping:</strong> The number of circumstances beneficiaries reported stress and
        inability to cope half of the time.
      </p>
      <p>
        <strong>Frequency of high coping:</strong> The number of circumstances beneficiaries reported no stress and
        the ability to cope. As can be seen from the first graph, the ability to cope was reported low when the
        families came to the center.
      </p>
      <p style="margin-top: 12px;">
        With subsequent counseling intervention, monitoring their stress levels and helping them enhance their problem
        solving and coping and adjustment skills; at the time of Discharge the families reported higher coping skills.
      </p>
    </div>

  </div>
</div>

